var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.769 6.741L9.242 4.214l1.826-1.827 2.526 2.526-1.825 1.828zm-6.506 6.513l-2.791.254.247-2.772L7.986 5.47l2.527 2.528-5.25 5.256zm9.68-9.645l-.001-.001-2.568-2.567C11.68.348 10.486.315 9.829.976L1.393 9.411a1.85 1.85 0 00-.534 1.138l-.355 3.91a.94.94 0 001.019 1.018l3.91-.356a1.85 1.85 0 001.138-.532l8.435-8.436c.683-.684.654-1.826-.063-2.544z",
    fill: "current"
  })));
}
export default SvgPencil;